const idToUrlObj = {
    // 下单催付-下单关怀（货到）
    11: '/orderCare/orderCare/goodsOrderCare',
    // 下单催付-常规催付
    8: '/orderCare/orderCare/expediting',
    // 下单催付-二次催付
    12: '/orderCare/orderCare/twiceExpediting',
    // 下单催付-预售尾款催付
    24: '/orderCare/orderCare/presaleExpediting',
    // 付款关怀-付款关怀
    1: '/orderCare/payReminder/payReminder',
    // 物流提醒-取消提醒
    6: '/orderCare/transreMind/cancelMind',
    // 物流提醒-发货提醒
    2: '/orderCare/transreMind/sendreMind',
    // 物流提醒-迟发提醒
    3: '/orderCare/transreMind/delayMind',
    // 物流提醒-派件提醒
    13: '/orderCare/transreMind/delivereMind',
    // 物流提醒-签收提醒
    14: '/orderCare/transreMind/recvreMind',
    // 物流提醒-退货提醒
    7: '/orderCare/transreMind/goodsBackMind',
    // 回款关怀-完成提醒
    5: '/orderCare/moneyBack/moneyBack',
    // 评价关怀-自动催评
    41: '/orderCare/comtCare/autoEvaluation',
    // 评价关怀-好评感谢
    42: '/orderCare/comtCare/thankEvaluation',
    // 评价关怀-中差评安抚
    43: '/orderCare/comtCare/poorEvaluation',
    // 退款关怀-申请退款
    51: '/orderCare/refunCare/apply',
    // 退款关怀-同意退款
    52: '/orderCare/refunCare/agree',
    // 退款关怀-拒绝退款
    53: '/orderCare/refunCare/deny',
    // 退款关怀-退款成功
    54: '/orderCare/refunCare/suces',
    // 精准营销-精准营销
    61: '/marketing/marketing/accurate_market',
    // 精准营销-智能营销
    62: '/marketing/marketing/intelligent_market',
    // 精准营销-会员发送
    63: '/marketing/marketing/member_send',
    // 精准营销-订单发送
    64: '/marketing/marketing/order_sent',
    // 精准营销-预售订单发送
    65: '/marketing/marketing/pop_presell_order_send',
    // 咚咚群聊-群聊营销
    66: '/marketing/chat/chat_Marketing',
    // 自动化营销-商品复购
    25: '/marketing/auto_marketing/goods_repurchase',
    // 自动化营销-首购有礼
    15: '/marketing/auto_marketing/first_purchase',
    // 自动化营销-复购有礼
    16: '/marketing/auto_marketing/repurchase',
    // 自动化营销-休眠提醒
    17: '/marketing/auto_marketing/sleep_remind',
    // 自动化营销-满月礼
    18: '/marketing/auto_marketing/fullmonthgift',
    // 自动化营销-百日礼
    19: '/marketing/auto_marketing/hundred_day_gift',
    // 自动化营销-周年庆
    20: '/marketing/auto_marketing/anniversary',
    // 自动化营销模型-开卡未购会员转化
    75: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-已购客户开卡转化
    76: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-首购有礼
    71: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-复购有礼
    72: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-兴趣客户转化
    74: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-流失客户召回
    73: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-商品复购
    84: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-直播提醒
    77: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-店铺上新提醒
    78: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-会员专享活动提醒
    79: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-会员积分使用提醒
    80: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-沉默会员召回-行业活跃
    81: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-店铺预售高潜人群关怀
    82: '/marketing/auto_marketing_official/auto_market_official_module',
    // 自动化营销模型-算法大促高转化人群营销
    83: '/marketing/auto_marketing_official/auto_market_official_module',
};

export default idToUrlObj 